module.exports = __webpack_public_path__ + "img/ucsdjsoe.d025302b.png";